import { IBoletoDepositoResponse } from '../entities/IBoletoDepositoResponse'
import IGerarBoletoDepositoRequest from '../entities/IGerarBoletoDepositoRequest'
import { IPagamentoRepository } from '../repositories/IPagamentoRepository'

export interface IGerarBoletoDeposito {
  execute(params: IGerarBoletoDepositoRequest): Promise<IBoletoDepositoResponse>
}

export default class GerarBoletoDepositoImpl implements IGerarBoletoDeposito {
  constructor(private readonly pagamentosRepository: IPagamentoRepository) {}
  async execute(
    params: IGerarBoletoDepositoRequest,
  ): Promise<IBoletoDepositoResponse> {
    return this.pagamentosRepository.gerarBoletoDeposito(params)
  }
}
